import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Spinner, VStack } from '@chakra-ui/react';
import { ContentTrackCard } from '@src/components/sco/Education/ContentTrackLanding/ContentTrackCard';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { gql } from '@src/lib/gql';
import React from 'react';
export const ContentTrackList = () => {
  const $ = _c(12);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ContentTrackList.queries.contentTracks();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  let t1;
  if ($[1] !== query.loading) {
    t1 = query.loading && <Center><Spinner /></Center>;
    $[1] = query.loading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== query.error) {
    t2 = query.error && <Box>{query.error?.toString()}</Box>;
    $[3] = query.error;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== getBreakpointValue || $[6] !== query.data?.contentTracks) {
    t3 = query.data?.contentTracks && <VStack gap={getBreakpointValue([4, 4, 6, 10])} width="full">{query.data?.contentTracks?.map((contentTrack, index) => <ContentTrackCard key={contentTrack.id} bgColor="colorPalette.container" bgDir={getBreakpointValue([index % 2 ? "bottom left" : "bottom right"])} contentTrack={contentTrack} direction={getBreakpointValue([index % 2 ? "column-reverse" : "column", index % 2 ? "column-reverse" : "column", index % 2 ? "column-reverse" : "column", index % 2 ? "row" : "row-reverse", index % 2 ? "row" : "row-reverse"])} fadeDir={index % 2 ? "to-bl" : "to-br"} />)}</VStack>;
    $[5] = getBreakpointValue;
    $[6] = query.data?.contentTracks;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <VStack gap={0} width="full">{t1}{t2}{t3}</VStack>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
ContentTrackList.queries = {
  contentTracks: () => gql`
    query {
      contentTracks(where: { type_in: [Bootcamp, Course, Track] }) {
        id
        color {
          hex
        }
        sections {
        id
        steps {
          id
          tasks {
            id
          }
        }
      }
        ${ContentTrackCard.fragments.ContentTrack()}
      }
    }
  `
};